import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PatientControlButton from 'components/atoms/patentControlButton';
import GeneralCommentIcon from 'components/atoms/icons/generalCommentIcon';
import GeneralCommentModalNew from 'components/templates/rpm/patients/patient/generalComments/modal-new';
import { useSendComment } from 'infrastructure/hooks/comments/use-send';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

import type { ICreateComment } from 'infrastructure/interfaces';
import type { ModuleType } from 'infrastructure/enums';

interface IProps {
  module: ModuleType;
  patientGuid: string;
}

const GeneralCommentsControl: React.FC<IProps> = (props) => {
  const { module, patientGuid } = props;
  const { t } = useTranslation();

  const {
    patientInfo,
    isCombinedModule,
    isReadOnlyRole,
    isBlockCcmModule,
    isBlockRpmModule,
    isCcmActionDisabled,
  } = useAccess({
    module,
    patientGuid,
  });
  const { loading: commentLoading, sendComment } = useSendComment();

  const [open, setOpen] = useState(false);

  const sendCommentHandler = async (data: ICreateComment) => {
    const response = await sendComment(data);
    setOpen(false);
    return response;
  };

  return (
    <>
      <PatientControlButton
        label={t('labels.generalComments')}
        Icon={GeneralCommentIcon}
        loading={commentLoading}
        disabled={isCombinedModule ? isReadOnlyRole : isCcmActionDisabled}
        handleClick={() => setOpen(true)}
      />

      <GeneralCommentModalNew
        isOpen={open}
        toggle={setOpen}
        patientGuid={patientGuid}
        loading={commentLoading}
        submit={sendCommentHandler}
        module={module}
        interactionStatus={patientInfo?.interactionStatus}
        tabsProps={{
          showTabs: isCombinedModule,
          disableCcm: isBlockCcmModule,
          disableRpm: isBlockRpmModule,
        }}
      />
    </>
  );
};

export default GeneralCommentsControl;
